module.exports = __webpack_public_path__ + "static/media/frutiger-55roman.41993bac.eot";